import { Command } from "./command.js";
/**
 * @see https://redis.io/commands/ping
 */
export class PingCommand extends Command {
    constructor(cmd, opts) {
        const command = ["ping"];
        if (typeof cmd !== "undefined" && typeof cmd[0] !== "undefined") {
            command.push(cmd[0]);
        }
        super(command, opts);
    }
}
